import { StatusType } from './constants';
import { AvailabilityCurrentUserState, CurrentAvailabilityUser } from './types';

export enum AvailabilityCurrentUserActionType {
  InitStart = 'init-start',
  InitSuccess = 'init-success',
  InitError = 'init-error',
  SetStatus = 'set-status',
}

export type AvailabilityCurrentUserAction =
  | Readonly<{
      type: AvailabilityCurrentUserActionType.InitStart;
    }>
  | Readonly<{
      type: AvailabilityCurrentUserActionType.InitSuccess;
      payload: CurrentAvailabilityUser;
    }>
  | Readonly<{
      type: AvailabilityCurrentUserActionType.InitError;
      payload: string;
    }>
  | Readonly<{
      type: AvailabilityCurrentUserActionType.SetStatus;
      payload: StatusType;
    }>;

export const initialAvailabilityCurrentUserState: AvailabilityCurrentUserState = {
  user: null,
  loading: false,
  error: null,
};

export const availabilityCurrentUserReducer = (
  state: AvailabilityCurrentUserState,
  action: AvailabilityCurrentUserAction,
): AvailabilityCurrentUserState => {
  switch (action.type) {
    case AvailabilityCurrentUserActionType.InitStart:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case AvailabilityCurrentUserActionType.InitSuccess:
      return {
        user: action.payload,
        loading: false,
        error: null,
      };
    case AvailabilityCurrentUserActionType.InitError:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case AvailabilityCurrentUserActionType.SetStatus:
      return {
        ...state,
        user: state.user ? { ...state.user, status: action.payload } : state.user,
      };
    default:
      return state;
  }
};
